import { Link as RouterLink } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Stack, Link, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import { LoginForm } from "../components/authentication/login";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
	[theme.breakpoints.up("md")]: {
		display: "flex",
	},
}));

const ContentStyle = styled("div")(({ theme }) => ({
	maxWidth: 480,
	margin: "auto",
	display: "flex",
	minHeight: "100vh",
	flexDirection: "column",
	justifyContent: "center",
	padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
	return (
		<RootStyle title="Login">
			<Container maxWidth="sm">
				<ContentStyle>
					<Stack sx={{ mb: 5 }}>
						<Typography variant="h4" gutterBottom>
							Sign in to SSBU.
						</Typography>
						<Typography sx={{ color: "text.secondary" }}>
							Enter your details below.
						</Typography>
					</Stack>
					{/* <AuthSocial /> */}

					<LoginForm />

					<MHidden width="smUp">
						<Typography
							variant="body2"
							align="center"
							sx={{ mt: 3 }}
						>
							Don’t have an account?&nbsp;
							<Link
								variant="subtitle2"
								component={RouterLink}
								to="register"
							>
								Get started
							</Link>
						</Typography>
					</MHidden>
				</ContentStyle>
			</Container>
		</RootStyle>
	);
}
